import React from 'react';
import T from 'i18n-react';

import DropDown, { DropDownPropTypes } from './components/DropDown';

const DisciplineDropDown = ({ ...restProps }) => (
  <DropDown
    {...restProps}
    label={T.translate('new.discipline')}
    valueKey="key"
    placeholder={T.translate('filter.discipline')}
  />
);

// eslint-disable-next-line no-unused-vars
const { label, placeholder, valueKey, searchIcon, ...DisciplineDropDownPropTypes } = DropDownPropTypes;

DisciplineDropDown.propTypes = DisciplineDropDownPropTypes;
export default DisciplineDropDown;
